import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const policyTemplateAuthenticationStrengthRequirementsApi = createApi({
  reducerPath: 'policyTemplateAuthenticationStrengthRequirements',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getAuthenticationStrengthRequirementsPreview: builder.query({
      query: ({ templateId, customerId }) => ({
        url: `/secure/policy/template/${templateId}/authentication-strength-requirements/preview`,
        params: { customerId },
      }),
    }),
  }),
})

export const { useGetAuthenticationStrengthRequirementsPreviewQuery } =
  policyTemplateAuthenticationStrengthRequirementsApi

export const useAuthenticationStrengthRequirementsPreview = (
  { templateId, customerId: customerIdOverride },
  options = {},
) => {
  const selectedCustomerId = useSelector(getSelectedCustomerId)
  // Deploy from a check can target a different tenant than the globally selected customer.
  const customerId = customerIdOverride ?? selectedCustomerId

  // Deploy resolves against the tenant's live strengths, so every review must too — a cached
  // result could show "Will be created" for a strength that now exists.
  return useGetAuthenticationStrengthRequirementsPreviewQuery(
    { templateId, customerId },
    { refetchOnMountOrArgChange: true, ...options, skip: options.skip || !templateId || !customerId },
  )
}
